import { render, staticRenderFns } from "./PopupStaff.vue?vue&type=template&id=6fd76a3d"
import script from "./PopupStaff.vue?vue&type=script&lang=js"
export * from "./PopupStaff.vue?vue&type=script&lang=js"
import style0 from "./PopupStaff.vue?vue&type=style&index=0&id=6fd76a3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports